module.exports = __webpack_public_path__ + "static/media/studio-m-2022.74634800.png";